"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const override = {
    publicPath: "https://statics.teams.cdn.live.net",
};
exports.default = Object.assign(Object.assign({}, BaseConfig_1.default), override);
